import { Link, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import ServiceRequestActionMenu from "./ServiceRequestActionMenu";

export const serviceRequestListColumns = (isReadOnly) => [
  {
    field: "ticket_id",
    headerName: "Ticket ID",
    width: 120,
    renderCell: ({ value, row: { ticket_id } }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link
            underline="none"
            component={RouterLink}
            to={`edit/${ticket_id}`}
          >
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 200,
    renderCell: ({ value }) => (
      <Tooltip title={value} placement="top">
        <span>{value}</span>
      </Tooltip>
    ),
  },
  {
    field: "phone",
    headerName: "Phone No.",
    width: 130,
  },
  {
    field: "issueType",
    headerName: "Issue Type",
    width: 120,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    minWidth: 200,
    renderCell: ({ value }) => (
      <Tooltip title={value} placement="top">
        <span>{value}</span>
      </Tooltip>
    ),
  },
  {
    field: "createAt",
    headerName: "Date/Time",
    width: 180,
    type: "date",
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    renderCell: ({ id, row }) => {
      return <ServiceRequestActionMenu id={id} row={row} />;
    },
  },
];
